'use strict';

// Alt version of typeahead that uses sitecore search solution instead of twitter typeahead

class TypeaheadSSS {
    wrap;
    state;
    ui;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap && this.wrap.length) {
            this.ui = {
                input: $(this.wrap).find('.js-typeahead-sss-input'),
                menu: $(this.wrap).find('.js-typeahead-sss-menu'),
                link: $(this.wrap).find('.typeahead-sss__result a'),
                navInput: $('.nav-search--desktop .js-typeahead-sss-input')
            };

            this.setState({
                value: '',
                focused: false,
            });

            this.bindUIActions();
            this.disableAutoComplete();
        }
    }

    bindUIActions() {
        if (this.ui.input.length) {

            $(document).on('focusin', (e) => this.focusin(e));
            $(document).on('focusout', (e) => this.focusout(e));
            this.ui.input.on('keyup', (e) => this.inputChange(e));

            $('.js-nav-search--mobile .typeahead-sss__results').on('click touchstart', 'a', (e) => {
                window.location.href = $(e.currentTarget).attr('href');
            });
        }
    }

    focusin(e) {
        if (this.hasChildElement(e.target)) {
            this.setState({
                focused: true,
            });
        }
    }

    focusout(e) {
        if (!this.hasChildElement(e.relatedTarget)) {
            this.setState({
                focused: false,
            });
        }
    }

    inputChange(e) {
        this.setState({
            value: e.target.value,
        });
    }

    setState(change) {
        this.state = $.extend({}, this.state, change);

        this.updateView();
    }

    updateView() {
        if(this.state.focused && this.state.value && this.state.value.length > 2) {
            this.showMenu();
        } else {
            this.hideMenu();
        }
    }

    disableAutoComplete() {
        this.ui.input.attr('autocomplete', 'off');
    }

    hideMenu() {
        this.ui.menu.addClass('u-hidden');
    }

    showMenu() {
        this.ui.menu.removeClass('u-hidden');
    }

    hasChildElement(el) {
        return !!$(this.wrap).has(el).length;
    }
}

export default TypeaheadSSS;
